import { Status } from '../models/status.interfaces';

export const Delta360MedallionBannerStatusMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'DELTA 360®',
    level: '0',
    name: '360'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const Delta360MedallionBannerWithSkyPriorityStatusMocks: Status = {
  priority: {
    label: 'SKY PRIORITY',
    url: '/us/en/check-in-security/sky-priority',
    active: true
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'DELTA 360®',
    level: '0',
    name: '360'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const Delta360MedallionBannerStatusWithLifetimeMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '',
    subtitle: '',
    level: '0',
    name: '360'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const Delta360MedallionBannerWithSkyPriorityStatusWithLifetimeMocks: Status =
  {
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority',
      active: true
    },
    tier: {
      title: '',
      subtitle: '',
      level: '0',
      name: '360'
    },
    enrollDate: 'SKYMILES MEMBER SINCE 2004'
  };
